import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { apiService } from '../../services';
import { Parsers } from '../../helpers';
import { Message } from 'semantic-ui-react';

const FormsThanks = (props) => {
  const {
    updateFilledFormsURLAPI,
    match,
    t
  } = props;

  const [running, setRunning] = useState(false);
  const [error, setError] = useState();

  function updateFilledForms() {
    setRunning(true);
    const formID = Parsers.sanitizeString(match.params.formID);
    apiService
      .callServer(updateFilledFormsURLAPI, { ':formID:': formID })
      .then(() => {
        setRunning(false);
        setTimeout(function () { window.close(); }, 5000);
      })
      .catch(err => {
        setError(err && err.message ? err.message : 'An error occurred while updating filled forms');
      });
  }

  function renderError() {
    if (!error) {
      return null;
    }

    return (
      <Message
        className='error-message'
        error
        content={error}
      />
    );
  }

  useEffect(() => {
    if (!running) {
      updateFilledForms();
    }
  }, [match]);

  return (
    <div>
      {renderError()}
      {(
        <div className='thanks'>
          {(
            <div className='title bold'>
              {t('thanksMessage')}<br /><br />
              {t('closeTabMessage')}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const {
    updateFilledFormsURL
  } = state.api;

  return {
    updateFilledFormsURLAPI: updateFilledFormsURL
  };
}

const FormsThanksRouter = withTranslation('thanks')(withRouter(connect(mapStateToProps)(FormsThanks)));
export { FormsThanksRouter as FormsThanks };
